import React from "react";
import Home from "../../../components/Home/Home";

const StudyPoints = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default StudyPoints;
